import type { ComponentType } from 'react';
import { WidgetType } from './widget-registry';
import HeaderWidget from './header-widget';
import ParagraphWidget from './paragraph-widget';
import ImageWidget from './image-widget';
import ButtonWidget from './button-widget';
import DividerWidget from './divider-widget';
import SpacerWidget from './spacer-widget';
import SocialWidget from './social-widget';
import LogoWidget from './logo-widget';
import FooterWidget from './footer-widget';
import DateTimeCardWidget from './date-time-card-widget';
import VideoWidget from './video-widget';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const WIDGET_COMPONENTS: Partial<Record<WidgetType, ComponentType<any>>> = {
  [WidgetType.Header]: HeaderWidget,
  [WidgetType.Paragraph]: ParagraphWidget,
  [WidgetType.Image]: ImageWidget,
  [WidgetType.Video]: VideoWidget,
  [WidgetType.Button]: ButtonWidget,
  [WidgetType.Divider]: DividerWidget,
  [WidgetType.Spacer]: SpacerWidget,
  [WidgetType.Social]: SocialWidget,
  [WidgetType.Logo]: LogoWidget,
  [WidgetType.Footer]: FooterWidget,
  [WidgetType.DateTimeCard]: DateTimeCardWidget,
};
